function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { LoadingOverlay } from '@homeaway/react-loading-overlay';
import { SVGIcon } from '@homeaway/react-svg';
import { CLOSE__16 } from '@homeaway/svg-defs';
import classnames from 'classnames';
/* eslint-disable no-multi-spaces */

var ModalStructure = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ModalStructure, _Component);

  function ModalStructure() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleModalClick = function (e) {
      // Do not do anything as we are specifying false for closeOnOutsideClick
      if (_this.props.closeOnOutsideClick) {
        // currentTarget here is the `modal` div, which covers the entire screen
        // any clicks on the backdrop will have a target of modal
        // any clicks on the modal itself will have a target of modal-body, model-header, etc
        if (e.target !== e.currentTarget) {
          return;
        }

        e.stopPropagation();

        _this.props.onClose();
      }
    };

    _this.renderBackdrop = function () {
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: "-1",
        className: "Modal__backdrop"
      });
    };

    return _this;
  }

  var _proto = ModalStructure.prototype;

  // Helps with iOS specific bug: swiping on header or footer steals some sort of
  // focus that should be on modal-body, thus causing natural scrolling to freeze
  // until modal-body is tapped again
  _proto.preventTouchMove = function preventTouchMove(e) {
    e.preventDefault();
  };

  _proto.renderModalHeader = function renderModalHeader() {
    var _this$props = this.props,
        closeButton = _this$props.closeButton,
        closeText = _this$props.closeText,
        secondaryActionLabel = _this$props.secondaryActionLabel,
        secondaryActionCallback = _this$props.secondaryActionCallback,
        secondaryActionDisabled = _this$props.secondaryActionDisabled,
        onClose = _this$props.onClose,
        title = _this$props.title,
        isWorkflow = _this$props.isWorkflow,
        id = _this$props.id;
    var hasSecondaryAction = secondaryActionLabel && secondaryActionCallback && isWorkflow;
    var headerClass = classnames('Modal__header', {
      'Modal__header--no-close-btn': !closeButton,
      'Modal__header--no-title': !title
    });
    var titleClass = classnames('Modal__header-column', 'Modal__header-column--title ', {
      'Modal__header-column--center-align': hasSecondaryAction
    });
    return /*#__PURE__*/React.createElement("div", {
      onTouchMove: this.preventTouchMove,
      className: headerClass
    }, hasSecondaryAction && /*#__PURE__*/React.createElement("div", {
      className: "Modal__header-column Modal__header-column--secondary-action"
    }, /*#__PURE__*/React.createElement("button", _extends({
      type: "button",
      onClick: secondaryActionCallback,
      className: "Modal__header-btn Modal__header-btn--secondary-action"
    }, secondaryActionDisabled && {
      disabled: true
    }), /*#__PURE__*/React.createElement("span", {
      className: "Modal__button-flex Modal__button-flex--secondary-action"
    }, secondaryActionLabel))), title && /*#__PURE__*/React.createElement("div", {
      className: titleClass
    }, /*#__PURE__*/React.createElement("h4", {
      id: id + "-label",
      className: "Modal__title"
    }, title)), closeButton && /*#__PURE__*/React.createElement("div", {
      className: "Modal__header-column Modal__header-column--close"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onClose,
      className: "Modal__header-btn Modal__header-btn--close",
      "aria-label": closeText
    }, /*#__PURE__*/React.createElement("span", {
      className: "Modal__button-flex",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      markup: CLOSE__16
    })))));
  };

  _proto.renderModalContent = function renderModalContent() {
    var _this2 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        header = _this$props2.header,
        footer = _this$props2.footer,
        id = _this$props2.id,
        isInstructional = _this$props2.isInstructional,
        isLoading = _this$props2.isLoading,
        isWorkflow = _this$props2.isWorkflow,
        isContextual = _this$props2.isContextual,
        modalBodyRef = _this$props2.modalBodyRef,
        closeOnEsc = _this$props2.closeOnEsc,
        closeOnOutsideClick = _this$props2.closeOnOutsideClick,
        isOpen = _this$props2.isOpen,
        modalAnimation = _this$props2.modalAnimation,
        timeouts = _this$props2.timeouts,
        title = _this$props2.title,
        onClose = _this$props2.onClose,
        closeButton = _this$props2.closeButton,
        closeText = _this$props2.closeText;
    var modalStyles = {
      display: 'block'
    };
    var modalClassName = classnames(className, 'Modal', {
      'Modal--contextual': isContextual
    });
    var modalContentClassName = classnames('Modal__content', isInstructional ? 'Modal__content--instructional' : '', isWorkflow ? 'Modal__content--workflow' : '');
    var modalBodyClassName = classnames('Modal__body', {
      'Modal__body--no-header': !header
    });
    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(c) {
        _this2.dialog = c;
      },
      className: modalClassName,
      id: id,
      style: modalStyles,
      onClick: this.handleModalClick,
      tabIndex: "-1",
      role: "dialog",
      "aria-labelledby": id + "-label",
      "aria-modal": "true"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Modal__dialog"
    }, /*#__PURE__*/React.createElement("div", {
      className: modalContentClassName,
      role: "document"
    }, isLoading && /*#__PURE__*/React.createElement(LoadingOverlay, null), header && this.renderModalHeader(), /*#__PURE__*/React.createElement("div", {
      ref: modalBodyRef,
      className: modalBodyClassName
    }, children), footer && /*#__PURE__*/React.createElement("div", {
      onTouchMove: this.preventTouchMove,
      className: "Modal__footer"
    }, footer))));
  };

  _proto.renderModalWrapper = function renderModalWrapper() {
    var _this$props3 = this.props,
        closeOnEsc = _this$props3.closeOnEsc,
        closeOnOutsideClick = _this$props3.closeOnOutsideClick,
        isOpen = _this$props3.isOpen,
        modalAnimation = _this$props3.modalAnimation,
        renderBackdrop = _this$props3.renderBackdrop,
        portalClassName = _this$props3.portalClassName,
        timeouts = _this$props3.timeouts;
    var useModalAnimation = modalAnimation !== 'none';
    return /*#__PURE__*/React.createElement("div", {
      className: portalClassName
    }, renderBackdrop && useModalAnimation && /*#__PURE__*/React.createElement(CSSTransition, {
      in: isOpen,
      classNames: "Modal__backdrop",
      timeout: {
        enter: timeouts.backdrop.transitionEnterTimeout,
        exit: timeouts.backdrop.transitionExitTimeout
      },
      mountOnEnter: true,
      unmountOnExit: true
    }, this.renderBackdrop()), renderBackdrop && !useModalAnimation && isOpen && this.renderBackdrop(), useModalAnimation && /*#__PURE__*/React.createElement(CSSTransition, {
      in: isOpen,
      classNames: modalAnimation,
      timeout: {
        enter: timeouts.modal.transitionEnterTimeout,
        exit: timeouts.modal.transitionExitTimeout
      },
      mountOnEnter: true,
      unmountOnExit: true
    }, this.renderModalContent()), !useModalAnimation && isOpen && this.renderModalContent());
  };

  _proto.render = function render() {
    var parentNode = this.props.parentNode;
    var usePortal = parentNode && typeof window !== 'undefined';
    return /*#__PURE__*/React.createElement(React.Fragment, null, !usePortal && this.renderModalWrapper(), usePortal && ReactDOM.createPortal(this.renderModalWrapper(), parentNode));
  };

  return ModalStructure;
}(Component);

ModalStructure.propTypes = {
  /** id attribute for the modal. Used to generate aria-labeledby attributes as well */
  id: PropTypes.string.isRequired,

  /** Flag to determine if the Modal has a close "x" button in the header */
  closeButton: PropTypes.bool,

  /** Screen Reader only text for close button in Modal Header */
  closeText: PropTypes.string.isRequired,

  /** Flag for if the Modal Header is shown */
  header: PropTypes.bool,

  /** The callback function for the secondary action button. Only applicable for isWorkflow modals at "mobile" widths. */
  secondaryActionCallback: PropTypes.func,

  /** Flag to determine if secondary action button is disabled. Only applicable for isWorkflow modals at "mobile" widths. */
  secondaryActionDisabled: PropTypes.bool,

  /** The text or html to display on the secondary action button. Only applicable for isWorkflow modals at "mobile" widths. */
  secondaryActionLabel: PropTypes.node,

  /** The Modal Heading in .modal-title. Used as the label for the modal if provided. */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** React Component for Modal footer */
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),

  /** Flag to determine if the Modal should display a loading overlay */
  isLoading: PropTypes.bool,

  /** Flag to determine if the Modal should be styled as "instructional" */
  isInstructional: PropTypes.bool,

  /** Flag to determine if the Modal should be styled as "modal-content--workflow" (more compact mobile styling) */
  isWorkflow: PropTypes.bool,

  /** Flag to determine if the Modal should be styled as "contextual" (mobile styling that is not full viewport size in order to help maintain context) */
  isContextual: PropTypes.bool,

  /** ReactCSSTransitionGroup transitionName for modal animation */
  modalAnimation: PropTypes.oneOf(['modal-from-center', 'modal-from-bottom', 'modal-from-left', 'modal-from-right', 'none']),

  /** Flag to determine if the dark backdrop should be rendered. **/
  renderBackdrop: PropTypes.bool,

  /** Timeout object for transitions */
  timeouts: PropTypes.shape({
    backdrop: PropTypes.shape({
      transitionEnterTimeout: PropTypes.number,
      transitionExitTimeout: PropTypes.number
    }),
    modal: PropTypes.shape({
      transitionEnterTimeout: PropTypes.number,
      transitionExitTimeout: PropTypes.number
    })
  })
};
ModalStructure.defaultProps = {
  closeButton: null,
  header: null,
  footer: null,
  modalAnimation: 'modal-from-center',
  parentNode: null,
  portalClassName: null,
  renderBackdrop: true,
  title: null,
  timeouts: {
    backdrop: {
      transitionEnterTimeout: 250,
      transitionExitTimeout: 250
    },
    modal: {
      transitionEnterTimeout: 350,
      transitionExitTimeout: 350
    }
  }
};
export default ModalStructure;
//# sourceMappingURL=ModalStructure.js.map